<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="一体柜" prop="re_dev_name"></el-table-column>
      <!-- 修改这里：使用formatter格式化日期 -->
      <el-table-column label="调控日期" prop="push_date" :formatter="formatDate"></el-table-column>
      <el-table-column label="说明" prop="remark"></el-table-column>

      <el-table-column label="创建时间" prop="create_time" :formatter="formatDateTime"></el-table-column>
      <!-- <el-table-column label="推送状态" prop="push_flag">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.push_flag == true">已推送</el-tag>
          <el-tag type="danger" v-else>未推送</el-tag>
        </template>
</el-table-column>
<el-table-column label="推送时间" prop="push_time"></el-table-column> -->
      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
          <el-button type="text"   @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <!-- 新增or修改策略 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isDetail ? '策略详情' : '新增策略'" width="1200px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="120px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="策略名称" prop="name" label-width="20%">
              <el-input placeholder="请输入策略名称" v-model="form.name" :disabled="isDetail" />
            </el-form-item>
            <el-form-item label="一体柜" prop="re_dev_id" label-width="20%">
              <el-select v-model="form.re_dev_id" placeholder="请选择一体柜" clearable :disabled="isDetail">
                <el-option v-for="item in PowerCabinetOptions" :key="item.ID" :label="item.name"
                  :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="控制日期" prop="push_date" label-width="20%">
              <el-date-picker v-model="form.push_date" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" style="width: 200px; margin-right: 10px" :disabled="isDetail" />
            </el-form-item>
            <el-form-item label="备注" prop="remark" label-width="20%">
              <el-input type="textarea" placeholder="请输入备注" :row="2" v-model="form.remark" :disabled="isDetail" />
            </el-form-item>

            <el-form-item label="调控时段" prop="timePowers" label-width="20%">
              <div class="time-slot-container">
                <div v-for="(slot, index) in form.timePowers" :key="index" class="time-slot-item">
                  <el-time-select style="width: 120px" v-model="slot.start_min"
                    :picker-options="{ start: '00:00', step: '00:15', end: '23:59' }" placeholder="选择分钟"
                    :disabled="isDetail"> </el-time-select>
                  <el-time-select style="width: 120px" v-model="slot.end_min"
                    :picker-options="{ start: '00:00', step: '00:15', end: '23:59' }" placeholder="选择分钟"
                    :disabled="isDetail"> </el-time-select>

                  <span style="margin: 0 5px">功率(kW):</span>
                  <el-input-number v-model="slot.start_power" placeholder="开始功率" :min="1" :max="1000" :step="1"
                    :precision="0" style="width: 150px; margin-right: 10px" :disabled="isDetail" />

                  <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeTimeSlot(index)"
                    v-if="form.timePowers.length > 1 && !isDetail"></el-button>
                </div>
                <el-button type="primary" icon="el-icon-plus" @click="addTimeSlot" style="margin-top: 10px"
                  v-if="!isDetail">添加时段</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button type="success" @click="onSubmit(2)" v-if="!isDetail">立即执行</el-button>
        <el-button type="success" @click="execute()" v-if="isDetail">立即执行</el-button>
        <el-button @click="visible.editGroup = false">取消</el-button>
        <el-button type="primary" @click="onSubmit(1)" v-if="!isDetail">确定</el-button>
        <!-- <el-button type="success" @click="onPush" v-if="!isDetail">下发</el-button>
        <el-button type="success" @click="onPush" v-if="isDetail">下发</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { GetCabinetPagelist, Add, SendTimelyControl, Delete, SendOrderById } from "@/api/dev_timely_control"
import { getPowerCabinetList } from "@/api/dev_archive"

import { mapGetters } from "vuex"

export default {
  name: "SpecialControl",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      visible: {
        editGroup: false
      },
      tableData: [],
      PowerCabinetOptions: [], // 一体柜选项
      form: {
        name: "",
        re_dev_id: "", // 一体柜ID
        re_type: "10", // EnumTimelyControl 一体柜 = 10,一体柜 = 11,
        timePowers: [
          {
            start_min: "", //开始分钟
            end_min: "", //结束分钟
            start_power: 6 //开始功率
          }
        ]
      },
      formRules: {
        name: [{ required: true, message: "请输入策略名称", trigger: "blur" }],
        re_dev_id: [{ required: true, message: "请选择一体柜", trigger: "change" }],
        push_date: [{ required: true, message: "请选择控制日期", trigger: "change" }],
        timePowers: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error("请至少设置一个充电时段"))
                return
              }

              for (let i = 0; i < value.length; i++) {
                const slot = value[i]
                if (!slot.start_min) {
                  callback(new Error(`第${i + 1}个时段：请选择时间`))
                  return
                }

                if (slot.start_power === null || slot.start_power === undefined || slot.start_power === "") {
                  callback(new Error(`第${i + 1}个时段：请输入功率`))
                  return
                }

                if (slot.start_power <= 0) {
                  callback(new Error(`第${i + 1}个时段：功率必须大于0`))
                  return
                }
              }

              callback()
            },
            trigger: "change"
          }
        ]
      },
      filter: {
        groupName: ""
      },
      loading: false,
      isDetail: false // 是否是详情模式
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    // 格式化日期，只显示年月日
    formatDate(row, column, cellValue, index) {
      if (!cellValue) return ''
      
      // 如果已经是yyyy-MM-dd格式，直接返回
      if (cellValue && cellValue.includes && cellValue.includes(" ")) {
        return cellValue.split(" ")[0] // 只取年月日部分
      }

      return cellValue
    },

    // 格式化日期时间，显示完整的年月日时分秒
    formatDateTime(row, column, cellValue, index) {
      if (!cellValue) return ""
      return cellValue
    },

    // 获取默认日期时间
    getDefaultDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, "0")
      const day = now.getDate().toString().padStart(2, "0")
      const hours = "08"
      const minutes = "00"
      const seconds = "00"
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 添加时段
    addTimeSlot() {
      this.form.timePowers.push({
        time: this.getDefaultDateTime(),
        power: 6
      })
    },

    // 删除时段
    removeTimeSlot(index) {
      this.form.timePowers.splice(index, 1)
    },

    // 加载一体柜列表
    async loadPowerCabinetList() {
      try {
        const res = await getPowerCabinetList({ pagesize: 100000 })
        this.PowerCabinetOptions = res.data || []
      } catch (error) {
        console.error("加载一体柜列表失败:", error)
        this.$message.error("加载一体柜列表失败")
      }
    },

    async onDetail(row) {
      this.visible.editGroup = true
      this.isDetail = true

      // 复制行数据
      this.form = { ...row }

      // 如果push_date包含时间部分，只取日期部分
      if (this.form.push_date && this.form.push_date.includes(" ")) {
        this.form.push_date = this.form.push_date.split(" ")[0]
      }

      this.loadPowerCabinetList()

      this.form.timePowers = JSON.parse(row.order_json)
    },
    getDeFaultTimePowers() {
      var ret = [
        {
          start_min: "",
          end_mine: "",
          start_power: 5
        }
      ]
      return ret
    },
    onDelete(row) {
      this.$confirm("确定要删除这个策略吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          Delete({ ID: row.ID || row.id })
            .then((res) => {
              this.$message.success(`删除成功`)
              this.toFilter()
            })
            .catch((error) => {
              this.$message.error("删除失败")
            })
        })
        .catch(() => { })
    },

    getData() {
      this.loading = true
      GetCabinetPagelist({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null
      })
        .then((res) => {
          this.tableData = res.data || []
          this.pageParams.total = res.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    onAdd() {
      this.visible.editGroup = true
      this.isDetail = false
      this.form = {
        name: "",
        re_dev_id: "",
        re_type: 10,
        timePowers: this.getDeFaultTimePowers()
      }

      // 加载一体柜列表
      this.loadPowerCabinetList()

      // 重置表单验证
      if (this.$refs.groupForm) {
        this.$nextTick(() => {
          this.$refs.groupForm.clearValidate()
        })
      }
    },

    onSubmit(submitType) {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          this.form.triplet_id = this.PowerCabinetOptions.find((a) => a.ID == this.form.re_dev_id).triplet_id
          if (submitType == 1) {
            Add(this.form)
              .then((res) => {
                //this.$message.success(`执行成功`)
                this.$message.success(res.msg)
                this.visible.editGroup = false
                this.toFilter()
              })
              .catch((error) => {
                this.$message.error("执行失败")
              })
              .finally(() => {
                loading.close()
              })
          } else if (submitType == 2) {
            SendTimelyControl(this.form)
              .then((res) => {
                this.$message.success(`添加成功`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .catch((error) => {
                this.$message.error("添加失败")
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    },
    execute() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            Id: this.form.ID
          }
          SendOrderById(reqData)
            .then((res) => {
              //this.$message.success(`执行成功`)
              this.$message.success(res)
              this.visible.editGroup = false
              this.toFilter()
            })
            .catch((error) => {
              this.$message.error("执行失败")
            })
            .finally(() => {
              loading.close()
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.time-slot-container {
  width: 100%;
}

.time-slot-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}
</style>
